export default __webpack_public_path__ + "static/media/sa-icon.ee7eae6d.svg";